import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import Link from '@components/link/Link.tsx';
import setSpacesInText from '@functions/setSpacesInText.ts';

import I from '../types.ts';

const renderFoot: I['renderFoot'] = function () {
    const { article } = this.state;
    const { device } = this.props;

    if (!article || (!article.nextArticle && !article.prevArticle)) {
        return <></>;
    }

    return (
        <div className="publicBlogInner__foot _ROW">
            {(['prevArticle', 'nextArticle'] as const).map((key) => {
                if (!article[key]) {
                    return <></>;
                }

                const isOne = !article.prevArticle || !article.nextArticle;

                return (
                    <Link
                        className={`publicBlogInner__footBlock _col ${isOne ? '_one' : ''} _${key}`}
                        key={key}
                        pageName="public-blog-inner"
                        ids={{ 2: article[key].url }}
                    >
                        <div className="publicBlogInner__footBlockInner _col">
                            <div className="publicBlogInner__footBlockTitle">
                                {key === 'prevArticle' ? (
                                    <>
                                        Предыдущий
                                        {device === 'mobile' && !isOne && <br />} материал:
                                    </>
                                ) : (
                                    <>
                                        Следующий
                                        {device === 'mobile' && !isOne && <br />} материал:
                                    </>
                                )}
                                <i className="publicBlogInner__footBlockTitleIcon">
                                    <Icon
                                        name={
                                            key === 'prevArticle' ? 'arrow-prev-2' : 'arrow-next-2'
                                        }
                                    />
                                </i>
                            </div>
                            <div
                                className="publicBlogInner__footBlockName"
                                dangerouslySetInnerHTML={{
                                    __html: setSpacesInText(article[key].title),
                                }}
                            ></div>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
};

export default renderFoot;
